import m from "../../geodata/es2015/egyptLow";
window.am4geodata_egyptLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/egyptLow.js
// module id = null
// module chunks = 